export default __webpack_public_path__ + "static/media/computer-icon.26b0e870.svg";